import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';

export default class Breadcrumb extends Component {
  view() {
    const discussion = this.attrs.discussion;
    if (!discussion) return null;

    // 获取群组信息（从 discussion 的属性中）
    const group = discussion.attribute && discussion.attribute('social_group');

    return (
      <div className="DiscussionBreadcrumb">
        <div className="breadcrumb-Component">
          {/* {group && (
              <Link 
                href={app.route('groupDetail', { id: group.id })} 
                className="params-span"
              >
                {group.name}/
              </Link>
          )} */}
          <Link 
            href={app.route.discussion(discussion)} 
            className="params-span current"
          >
            {discussion.title()}
          </Link>
        </div>
      </div>
    );
  }
}

